import React, { useLayoutEffect, useState } from "react";
import LayoutFooter from "../inc/LayoutFooter";
import LayoutHeader from "../inc/LayoutHeader";
import { useNavigate } from "react-router-dom";
import { RollbackOutlined, DeleteOutlined } from "@ant-design/icons";
import { Layout, Col, Row, Select, List, Space } from "antd";
import { Button, Card, Form, Spin, Avatar, Input } from "antd";
import {
  displayMessage,
  generateSlug,
  getAPI,
  postAPI,
} from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import {
  PRODUCT_CATEGORY,
  CREATE_PRODUCT,
  IMAGE_BASE_URL,
} from "../../constants/api";
import ImageSelect from "../images/ImageSelect";
import JoditEditor from "jodit-react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

function ProductAdd() {
  const { Content } = Layout;
  let history = useNavigate();
  let navigate = useNavigate();

  const [form] = Form.useForm();
  const [categoryList, setCategory] = useState([]);
  const [loading, setIsLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  // For Image Selection
  const [selectedImages, setSelectedImages] = useState([]);
  const openDialog = () => {
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  const handleDialogOk = (selectedImages) => {
    if (selectedImages.length > 0) {
      const selectedImage = selectedImages.map((image) => image);
      setSelectedImages(selectedImage);
      form.setFieldsValue({ product_image: selectedImage.length });
    } else {
      displayMessage(ERROR_MSG_TYPE, "Image not selected");
    }
  };

  const removeSelectedImage = (filePathToRemove) => {
    const updatedSelectedFileValues = selectedImages.filter(
      (filePath) => filePath.filePath !== filePathToRemove
    );
    console.log(updatedSelectedFileValues);
    setSelectedImages(updatedSelectedFileValues);
    form.setFieldsValue({ image: updatedSelectedFileValues.length });
  };

  useLayoutEffect(() => {
    getCategory();
  }, []);

  const getCategory = () => {
    setIsLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setIsLoading(false);
        setCategory(data.data.map((e) => ({ value: e.id, label: e.title })));
      } else {
        setCategory([]);
        setIsLoading(false);
      }
    };
    const errorFn = function () {
      setCategory([]);
      setIsLoading(false);
    };
    getAPI(PRODUCT_CATEGORY, successFn, errorFn, {});
  };

  // Handle title change and update slug
  const handleTitleChange = (event) => {
    const newTitle = event.target.value;
    form.setFieldsValue({ slug: generateSlug(newTitle) });
  };

  const createData = (values) => {
    setIsLoading(true);
    const jsonData = {
      product_name: values.product_name,
      product_amt: values.product_amt,
      slug: values.slug,
      product_category: values.product_category,
      product_description: values.product_description,
      seo_title: values.seo_title,
      seo_keyword: values.seo_keyword,
      seo_description: values.seo_description,
      product_images: Array.from(selectedImages).map((element) => element.id),
    };
    const successFn = function (data) {
      if (data.status === true) {
        setIsLoading(false);
        history("/product");
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Save Data");
    };
    postAPI(CREATE_PRODUCT, jsonData, successFn, errorFn);
  };
  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Spin spinning={loading}>
            <Card
              title="Create Product"
              bordered={false}
              extra={
                <Button
                  style={{
                    marginTop: "5px",
                    marginBottom: "5px",
                  }}
                  onClick={() => navigate(-1)}
                  type="primary"
                  ghost
                >
                  <RollbackOutlined />
                </Button>
              }
            >
              <Form form={form} layout="vertical" onFinish={createData}>
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Form.Item
                      name="product_name"
                      label="Product Name"
                      rules={[
                        {
                          required: true,
                          message: "Product Name is required!",
                        },
                      ]}
                      onChange={handleTitleChange}
                    >
                      <Input type={"text"} placeholder="Product Name" />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item
                      name="slug"
                      label="Slug"
                      rules={[{ required: true, message: "Slug is required!" }]}
                    >
                      <Input disabled type={"text"} placeholder="Slug" />
                    </Form.Item>
                  </Col>

                  <Col span={4}>
                    <Form.Item
                      name="product_amt"
                      label="Product Amount"
                      rules={[
                        {
                          required: true,
                          message: "Product Amount is required!",
                        },
                      ]}
                    >
                      <Input type={"text"} placeholder="Product Amount" />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item
                      name="product_category"
                      label="Product Category"
                      rules={[
                        {
                          required: true,
                          message: "Product Category is required!",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        allowClear
                        placeholder="Select a Product Category"
                        optionFilterProp="label"
                        options={categoryList}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      name="seo_title"
                      label="SEO Title (Title Tag)"
                      rules={[
                        { required: true, message: "SEO Title is required!" },
                        {
                          min: 1,
                          max: 60,
                          message:
                            "SEO Title must be between 50 and 60 characters.",
                        },
                      ]}
                    >
                      <Input placeholder="SEO Title (Title Tag)" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="seo_keyword"
                      label="SEO Keyword"
                      rules={[
                        { required: true, message: "SEO Keyword is required!" },
                        {
                          min: 1,
                          max: 50,
                          message:
                            "SEO Keyword should be between 1 and 50 characters.",
                        },
                      ]}
                    >
                      <Input placeholder="SEO Keyword" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="seo_description"
                      label="SEO Meta Description"
                      rules={[
                        {
                          required: true,
                          message: "SEO Meta Description is required!",
                        },
                        {
                          min: 1,
                          max: 160,
                          message:
                            "SEO Meta Description must be between 150 and 160 characters.",
                        },
                      ]}
                    >
                      <Input.TextArea
                        rows={4}
                        placeholder="SEO Meta Description"
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      type="file"
                      name="product_image"
                      label="Room Images"
                      rules={[
                        { required: true, message: "Room Images is required!" },
                      ]}
                    >
                      <Input
                        type="text"
                        readOnly
                        onClick={openDialog}
                        value={
                          selectedImages.length === 0
                            ? "Click to select image"
                            : selectedImages.length
                        }
                        name="product_image"
                        placeholder="Click to select image"
                      />

                      {selectedImages.length !== 0 ? (
                        <List
                          grid={{
                            gutter: 16,
                            column: 3,
                          }}
                          dataSource={selectedImages}
                          renderItem={(element) => (
                            <Space>
                              <Avatar
                                size={{
                                  xs: 24,
                                  sm: 32,
                                  md: 40,
                                  lg: 64,
                                  xl: 80,
                                  xxl: 100,
                                }}
                                src={IMAGE_BASE_URL + element.filePath}
                                shape="square"
                              />
                              <Avatar
                                shape="circle"
                                size="small"
                                icon={
                                  <DeleteOutlined
                                    onClick={() =>
                                      removeSelectedImage(element.filePath)
                                    }
                                  />
                                }
                              />
                            </Space>
                          )}
                        />
                      ) : null}
                    </Form.Item>
                  </Col>
                  <Col span={18}>
                    <Form.Item
                      name="product_description"
                      label="Product Description"
                      rules={[
                        {
                          required: true,
                          message: "Product Description is required!",
                        },
                      ]}
                    >
                      <JoditEditor placeholder="Product Description" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row spceber>
                  <Col span={24}>
                    <Form.Item
                      style={{ float: "right" }}
                      label=""
                      colon={false}
                    >
                      <Button loading={loading} block htmlType="submit">
                        Submit
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
          </Spin>
        </Content>
        <LayoutFooter />
        <ImageSelect
          isOpen={isDialogOpen}
          onClose={closeDialog}
          onOk={handleDialogOk}
          fromMager={false}
        />
      </Layout>
    </>
  );
}
export default ProductAdd;
